<auto-main-navigation [accountId]="accountId"></auto-main-navigation>
<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">MPOP Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav"></p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <ng-template pTemplate="header">
        <div class="panel-header-content">
          <h2>Conversion Engine</h2>
          <button pButton class="p-button-success save-button" label="Save"
                  [disabled]="getSaveButtonDisabled() || isSaving"
                  (click)="saveSettings()"></button>
        </div>
      </ng-template>
      <p-tabView>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>
              Private Offers <i class="pi pi-lock"></i>
            </span>
          </ng-template>
          <auto-private-offers
            [data]="conversionSettings"
            (formGroupInitialized)="onPrivateOffersFormGroupInitialized($event)">
          </auto-private-offers>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>
              VDP Offers <i class="pi pi-car"></i>
            </span>
          </ng-template>
          <auto-vdp-offers
            [data]="conversionSettings"
            (formGroupInitialized)="onVdpOffersFormGroupInitialized($event)">
          </auto-vdp-offers>
        </p-tabPanel>
      </p-tabView>
    </p-panel>
  </div>
</p-panel>
<auto-footer></auto-footer>
